<template>
  <div class="seckill-popup-component">
    <ym-popup class="seckill-popup-popup"
              v-model="visible"
              :close-on-click-overlay="false"
              get-container="body"
    >
      <div v-if="title !== ''"
           class="seckill-popup-header"
      >
        {{ title }}
      </div>
      <div class="seckill-popup-content">
        <slot></slot>
      </div>
      <div v-if="showCloseBtn"
           class="seckill-popup-close"
           @click.stop="handleClose"
      >
        <ym-icon class="seckill-popup-close-icon"
                 name="round-close"
        />
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'SeckillPopup',
    components: {
      'ym-popup': Popup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        default: '',
      },
      showCloseBtn: {
        type: Boolean,
        default: true,
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClose() {
        this.visible = false;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @seckill-popup-width: 550px;
  @seckill-popup-header-height: 100px;
  .seckill-popup {
    &-popup {
      width: @seckill-popup-width;
      overflow-y: visible;
      border-radius: @seckill-popup-border-radius;
    }

    &-header {
      height: @seckill-popup-header-height;
      line-height: @seckill-popup-header-height;
      font-size: @font-size-extra-large;
      text-align: center;
      color: @color-white;
      background: @seckill-primary-gradient;
      border-radius: @seckill-popup-border-radius @seckill-popup-border-radius 0 0;
    }

    &-content {
      line-height: 1.5;
      border-radius: 0 0 @seckill-popup-border-radius @seckill-popup-border-radius;
    }

    @seckill-popup-close-size: 52px;
    @seckill-popup-close-bottom: @seckill-popup-close-size + @size-base;

    &-close {
      position: absolute;
      bottom: -@seckill-popup-close-bottom;
      left: 0;
      right: 0;
      margin: 0 auto;
      text-align: center;
      color: @color-white;

      &-icon {
        font-size: @seckill-popup-close-size;
      }
    }
  }
</style>
